module.exports = __webpack_public_path__ + "static/media/apachespark.f60cae06.svg";